/* RYTM "02 — Das System" section behaviour. Vanilla JS, no dependencies, safe for multiple instances per page. */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var SWIPE_THRESHOLD = 48;

  function initInstance(root) {
    if (root.dataset.rytmSystemInit === 'true') return;
    root.dataset.rytmSystemInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.rytm-system__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.rytm-system__panel'));
    var tablist = root.querySelector('.rytm-system__tabs');
    var stage = root.querySelector('.rytm-system__stage');
    if (!tabs.length || !panels.length) return;

    var mql = window.matchMedia(DESKTOP_QUERY);
    var activePhase = root.getAttribute('data-active-phase') || 'day';

    function applyState() {
      var isDesktop = mql.matches;

      tabs.forEach(function (tab) {
        var isSelected = tab.dataset.phase === activePhase;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.phase === activePhase;
        if (isDesktop) {
          panel.setAttribute('aria-hidden', 'false');
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        }
      });

      root.setAttribute('data-active-phase', activePhase);
    }

    function setPhase(phase, options) {
      if (phase !== 'day' && phase !== 'night') return;
      activePhase = phase;
      applyState();
      if (options && options.focus) {
        var tab = tabs.filter(function (t) { return t.dataset.phase === phase; })[0];
        if (tab) tab.focus();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setPhase(tab.dataset.phase);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (event) {
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;
        var nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        setPhase(tabs[nextIndex].dataset.phase, { focus: true });
      });
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', applyState);
    } else if (mql.addListener) {
      // Safari < 14 fallback.
      mql.addListener(applyState);
    }

    // Optional secondary gesture: swipe between phases on the stage.
    // The tabs remain the primary, always-visible control.
    if (stage) {
      var touchStartX = null;
      var touchStartY = null;

      stage.addEventListener('touchstart', function (event) {
        if (mql.matches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        if (mql.matches || touchStartX === null) return;
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;

        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

        var dayIndex = tabs.findIndex(function (t) { return t.dataset.phase === 'day'; });
        var nightIndex = tabs.findIndex(function (t) { return t.dataset.phase === 'night'; });
        if (deltaX < 0 && activePhase === 'day' && nightIndex !== -1) {
          setPhase('night');
        } else if (deltaX > 0 && activePhase === 'night' && dayIndex !== -1) {
          setPhase('day');
        }
      }, { passive: true });
    }

    applyState();
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-system]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-system]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a merchant adds/reorders this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();